export function validateMail(mail: string | undefined): boolean {
  if (!mail) return false;

  const re = /\S+@\S+\.\S+/;
  return re.test(mail);
}
